import script from "./Pic.vue?vue&type=script&setup=true&lang=js"
export * from "./Pic.vue?vue&type=script&setup=true&lang=js"

import "./Pic.vue?vue&type=style&index=0&id=3514b5ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3514b5ae"]])

export default __exports__